import { FormControl } from 'react-bootstrap'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * React component which renders a simple search box and trigers search result rendering on search box onChange event
 */
class SaxsSearchBarBelowEntityList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchOutput: this.props.data,
    }

    this.onChange = this.onChange.bind(this)
  }

  render() {
    return (
      <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
        <div style={{ flex: '1', overflowY: 'scroll' }}>{this.props.children(this.state.searchOutput)}</div>

        <div style={{ flex: '0 0 48px', padding: '5px', backgroundColor: '#d7d7d7' }}>
          <FormControl placeholder={this.props.placeholder} onChange={this.onChange} />
        </div>
      </div>
    )
  }

  /**
   * Callback triggered when the user inputs something in the input box
   */
  onChange(event) {
    const userInput = event.target.value
    const filteredData = this.props.filter(this.props.data, userInput)
    this.setState({ searchOutput: filteredData })
  }
}

export default SaxsSearchBarBelowEntityList

SaxsSearchBarBelowEntityList.propTypes = {
  /** raw data rendered on props.children which will be searched against */
  data: PropTypes.object,
  /** the callback which filters this.props.data. It returns the filtered data. An empty array otherwise */
  filter: PropTypes.func,
  /** Text shown as placeholder in the input box */
  placeholder: PropTypes.string,
}

SaxsSearchBarBelowEntityList.defaultProps = {
  placeholder: 'Search ...',
}
